// src/auth/constants/PublicImg.tsx
// Define the shape of an image object
interface ImageData {
  imgId: number;
  url: string;
  alt: string;
  title: string;
  category: "partner" | "branding" | "product" | "invention" | "default";
}

// Define valid categories as a constant
const VALID_CATEGORIES = ["partner", "branding", "product", "invention", "default"] as const;

// Array of public images with metadata
const publicImagesData: ImageData[] = [
  {
    imgId: 1,
    url: "https://www.artismymusic.com/static/media/logo.ffee978310e6835367641750451e7fe7.svg",
    alt: "Artis School of Music Logo",
    title: "Artis School of Music",
    category: "partner",
  },
  {
    imgId: 2,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2Folsme2024.png?alt=media&token=083c310d-0045-48c8-a516-786286b3cc1e",
    alt: "OLSME 2024 Price2024",
    title: "OLSME 2024",
    category: "branding",
  },
  {
    imgId: 3,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2FOLSLMmonitor.png?alt=media&token=5905456a-c6ca-4919-b032-dbcf29dd3d3e",
    alt: "OLSLM Monitor",
    title: "OLSLM Monitor",
    category: "product",
  },
  {
    imgId: 4,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2FOLSLM%20assets%20transfer%20.png?alt=media&token=1411a2fa-f0ed-433f-9be6-91f3a6991f5a",
    alt: "OLSLM assets transfer",
    title: "OLSLM assets transfer",
    category: "product",
  },
  {
    imgId: 5,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2FOLSLM%20asset%20logo.png?alt=media&token=3d9004c4-b830-4530-9ee8-2d3c1878cfbb",
    alt: "OLSLM asset logo",
    title: "OLSLM asset logo",
    category: "product",
  },
  {
    imgId: 6,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F962.OLSLM%20categories%20.png?alt=media&token=15948dd0-d2c3-43f8-b0dd-a5bca38a334c",
    alt: "OLSLM categories",
    title: "OLSLM categories",
    category: "product",
  },
  {
    imgId: 7,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F2800.OLStime12LH.png?alt=media&token=a7b3e61c-fa4a-4ce8-ab84-395979b60d72",
    alt: "OLSinvention-correct time",
    title: "OLSinvention-correct time",
    category: "invention",
  },
  {
    imgId: 8,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2F%20OLSLM%20OLSM%20OLSME.png?alt=media&token=68ed050d-cae6-4318-8843-c4ad72b096f5",
    alt: "OLSdata-OLSLM OLSM OLSME",
    title: "OLSdata-OLSLM OLSM OLSME",
    category: "invention",
  },
  {
    imgId: 9,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2FOLSMElogo.png?alt=media&token=2946c245-84a2-48b6-aaf1-7d6b642748f7",
    alt: "OLSME logo",
    title: "OLSME Logo",
    category: "default", // Changed from "Service" to "default"
  },
  {
    imgId: 10,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/img-public%2F2910.OLScalendar.png?alt=media&token=9805a7a3-f004-4df7-bf56-2cc675994b66",
    alt: "OLS calendar",
    title: "OLS calendar",
    category: "invention", // Changed from "Invention" to "invention"
  },
  {
    imgId: 11,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/images%2FLessonsReview.png?alt=media&token=858ad8d4-9fc4-4cd1-a008-4db5433b351f",
    alt: "OLS testimonialLessonsReview",
    title: "OLS testimonialLessonsReview",
    category: "default", // Changed from "Service" to "default", is it Review possible ?
  },
  {
    imgId: 12,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/img-public%2F2920.OLSLM%20logo.png?alt=media&token=34b012f0-92fa-4c1b-beee-bdaacfc7eddd",
    alt: "OLSLM logo ",
    title: "OLSLM logo",
    category: "default", // OLSLM logo 
  },
  {
    imgId: 13,
    url: "https://firebasestorage.googleapis.com/v0/b/olsdata-550ld.appspot.com/o/img-public%2F2953.referral.png?alt=media&token=447b948f-7b14-443e-83cb-db416a5bc715",
    alt: "OLS2953 ",
    title: "OLS2953",
    category: "default", // OLS update
  },
  //
];

// Default fallback image URL
const DEFAULT_IMAGE_URL = "https://via.placeholder.com/150?text=Image+Not+Found";

// Utility function to get image URL by index with validation and fallback
const getImageUrl = (index: number): string => {
  if (typeof index !== "number") {
    console.error(`getImageUrl: Expected a number, but got ${typeof index}`);
    return DEFAULT_IMAGE_URL;
  }
  if (index < 0) {
    console.error(`getImageUrl: Index cannot be negative, got ${index}`);
    return DEFAULT_IMAGE_URL;
  }
  if (index >= publicImagesData.length) {
    console.warn(`getImageUrl: Index ${index} is out of bounds, using default image`);
    return DEFAULT_IMAGE_URL;
  }
  const url = publicImagesData[index]?.url;
  return url && typeof url === "string" ? url : DEFAULT_IMAGE_URL;
};

// Utility function to get image metadata by index
const getImageMetadata = (index: number): ImageData => {
  if (typeof index !== "number" || index < 0 || index >= publicImagesData.length) {
    return {
      imgId: -1,
      url: DEFAULT_IMAGE_URL,
      alt: "Image Not Found",
      title: "Image Not Found",
      category: "default",
    };
  }
  return publicImagesData[index];
};

// Utility function to get image metadata by imgId
const getImageById = (imgId: number): ImageData => {
  const image = publicImagesData.find((img) => img.imgId === imgId);
  if (!image) {
    console.warn(`getImageById: No image found with imgId ${imgId}, using default image`);
    return {
      imgId: -1,
      url: DEFAULT_IMAGE_URL,
      alt: "Image Not Found",
      title: "Image Not Found",
      category: "default",
    };
  }
  return image;
};

// Utility function to get all images by category
const getImagesByCategory = (category: ImageData["category"]): ImageData[] => {
  if (!VALID_CATEGORIES.includes(category)) {
    console.warn(`getImagesByCategory: Invalid category ${category}, returning empty array`);
    return [];
  }
  return publicImagesData.filter((img) => img.category === category);
};

// Export individual arrays for backward compatibility
export const publicImgURLs: string[] = publicImagesData.map((item) => item.url);

// Export structured data for advanced usage
export const publicImages = {
  images: publicImagesData,
  childQuestions: [] as any[], // Placeholder, can be typed further if needed
  getImageUrl,
  getImageMetadata,
  getImageById,
  getImagesByCategory,
};